module.exports = __webpack_public_path__ + "static/media/halo-massage-illus.624a4c36.svg";